import { Label, Select, SelectContent, SelectItem, SelectTrigger, SelectValue, Slider, SeedInput, Checkbox } from '@creanizer/ui'
import type { StoryLength, ChapterDetailLevel } from '@creanizer/types'
import type { CharacterInput, CharacterResult, SavedCharacter } from '../../../../types/character' // temp fix

interface PlotGeneratorFormProps {
  creativityLevel: number
  setCreativityLevel: (level: number) => void
  storyLength: StoryLength
  setStoryLength: (length: StoryLength) => void
  chapterDetailLevel: ChapterDetailLevel
  setChapterDetailLevel: (level: ChapterDetailLevel) => void
  seed: number | undefined
  setSeed: (seed: number | undefined) => void
  useProMode: boolean
  setUseProMode: (use: boolean) => void
  useGemini3FlashMode: boolean
  setUseGemini3FlashMode: (use: boolean) => void
}

export function PlotGeneratorForm({
  creativityLevel,
  setCreativityLevel,
  storyLength,
  setStoryLength,
  chapterDetailLevel,
  setChapterDetailLevel,
  seed,
  setSeed,
  useProMode,
  setUseProMode,
  useGemini3FlashMode,
  setUseGemini3FlashMode,
}: PlotGeneratorFormProps) {
  return (
    <>
      {/* 奇抜さレベル */}
      <div className="space-y-2">
        <div className="flex items-center justify-between">
          <Label>奇抜さレベル</Label>
          <span className="text-sm font-medium">{creativityLevel}</span>
        </div>
        <Slider
          value={[creativityLevel]}
          onValueChange={(v) => setCreativityLevel(v[0])}
          min={1}
          max={10}
          step={1}
        />
        <div className="flex justify-between text-xs text-gray-500">
          <span>保守的</span>
          <span>標準</span>
          <span>奇抜</span>
        </div>
      </div>

      {/* 物語の長さ */}
      <div className="space-y-2">
        <Label>物語の長さ</Label>
        <Select value={storyLength} onValueChange={(v) => setStoryLength(v as StoryLength)}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="short">短編（4-6章）</SelectItem>
            <SelectItem value="medium">中編（7-10章）</SelectItem>
            <SelectItem value="long">長編（11-15章）</SelectItem>
          </SelectContent>
        </Select>
      </div>

      {/* 章詳細度 */}
      <div className="space-y-2">
        <Label>章ごとのあらすじ詳細度</Label>
        <Select value={chapterDetailLevel} onValueChange={(v) => setChapterDetailLevel(v as ChapterDetailLevel)}>
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="standard">標準</SelectItem>
            <SelectItem value="increased">増加（標準の2倍以上）</SelectItem>
            <SelectItem value="detailed">詳細（更に詳しく）</SelectItem>
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground">
          章ごとのあらすじの文章量を調整できます
        </p>
      </div>

      {/* シード値 */}
      <div className="space-y-2">
        <Label htmlFor="seed">シード値</Label>
        <SeedInput
          id="seed"
          value={seed}
          onChange={setSeed}
        />
      </div>

      {/* Proモード */}
      <div className="flex items-center space-x-2">
        <Checkbox
          id="pro-mode"
          checked={useProMode}
          onCheckedChange={(checked) => setUseProMode(checked as boolean)}
        />
        <Label htmlFor="pro-mode" className="cursor-pointer">
          Proモード（より高性能なモデルを使用）
        </Label>
      </div>

      {/* Gemini 3 Flashモード */}
      <div className="flex items-center space-x-2">
        <Checkbox
          id="gemini3-flash-mode"
          checked={useGemini3FlashMode}
          onCheckedChange={(checked) => setUseGemini3FlashMode(checked as boolean)}
        />
        <Label htmlFor="gemini3-flash-mode" className="cursor-pointer">
          Gemini 3 Flash モード（試験版）
        </Label>
      </div>
    </>
  )
}